import React from 'react';
import '../styles/components/ServiceModal.scss';

const ServiceModal = ({ service, isOpen, onClose }) => {
  if (!isOpen) return null;
  
  console.log('ServiceModal received service:', service); // Debug log

  if (!service) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content">
          <div className="error-message">
            <h3>Service not found</h3>
            <p>The requested service could not be loaded.</p>
            <button onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  const features = service.features || [];
  const detailedInfo = service.detailedInfo || {};

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
        
        <div className="service-modal">
          {/* Header Section */}
          <div className="modal-header" style={{ borderLeftColor: service.color }}>
            <div className="service-icon" style={{ backgroundColor: service.color }}>
              <i className={service.icon}></i>
            </div>
            <div className="header-content">
              <h2>{service.title}</h2>
              <span className="service-abbr">{service.abbreviation}</span>
              <p className="service-tagline">{service.description}</p>
            </div>
          </div>

          {/* Main Content */}
          <div className="modal-body">
            {/* Service Image */}
            <div className="service-image-section">
              <img 
                src={service.image} 
                alt={service.title}
                className="service-modal-image"
                onError={(e) => {
                  e.target.src = '/images/service-default.jpg';
                }}
              />
            </div>

            {/* Full Description */}
            <div className="description-section">
              <h3>Service Overview</h3>
              <p>{service.fullDescription}</p>
            </div>

            {/* Our Approach */}
            {detailedInfo.approach && (
              <div className="approach-section">
                <h3>Our Approach</h3>
                <p>{detailedInfo.approach}</p>
              </div>
            )}

            {/* Key Features */}
            {features.length > 0 && (
              <div className="features-section">
                <h3>What We Offer</h3>
                <div className="features-grid">
                  {features.map((feature, index) => (
                    <div key={index} className="feature-item" style={{ borderColor: service.color }}>
                      <i className="fas fa-check" style={{ color: service.color }}></i>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Methodologies */}
            {detailedInfo.methodologies && detailedInfo.methodologies.length > 0 && (
              <div className="methodologies-section">
                <h3>Our Methodologies</h3>
                <div className="methodologies-list">
                  {detailedInfo.methodologies.map((method, index) => (
                    <div key={index} className="methodology-item">
                      <div className="methodology-icon">
                        <i className="fas fa-cog" style={{ color: service.color }}></i>
                      </div>
                      <span>{method}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Benefits */}
            {detailedInfo.benefits && detailedInfo.benefits.length > 0 && (
              <div className="benefits-section">
                <h3>Key Benefits</h3>
                <div className="benefits-grid">
                  {detailedInfo.benefits.map((benefit, index) => (
                    <div key={index} className="benefit-card" style={{ borderTopColor: service.color }}>
                      <i className="fas fa-star" style={{ color: service.color }}></i>
                      <p>{benefit}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Case Studies */}
            {detailedInfo.caseStudies && detailedInfo.caseStudies.length > 0 && (
              <div className="case-studies-section">
                <h3>Recent Projects</h3>
                <div className="case-studies-grid">
                  {detailedInfo.caseStudies.map((study, index) => (
                    <div key={index} className="case-study-card">
                      <h4>{study.title}</h4>
                      <p className="study-description">{study.description}</p>
                      <div className="study-outcome">
                        <strong>Outcome: </strong>
                        {study.outcome}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Call to Action */}
            <div className="modal-actions">
              <button 
                className="btn-primary" 
                style={{ backgroundColor: service.color }}
                onClick={() => window.location.href = '/contact'}
              >
                <i className="fas fa-envelope"></i>
                Request This Service
              </button>
              <button 
                className="btn-outline" 
                style={{ borderColor: service.color, color: service.color }}
                onClick={() => window.location.href = '/contact'}
              >
                <i className="fas fa-calendar"></i>
                Schedule Consultation
              </button>
              <button className="btn-secondary" onClick={onClose}>
                <i className="fas fa-times"></i>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;